import axios from 'axios';
import config from '@/vue-caas/config/config.js';

const baseURI = config.backupApiUrl;
const tempURI = config.adHelperApiUrl;
const setupURI = config.setupApiUrl;
const monitoringURI = config.monitoringApiUrl;
const prnrURI = config.companyApiUrl;
//const testURI = 'http://127.0.0.1:3000';
const sysLogURI = config.logTracerApiUrl;

const adminStoreModule = {
  state: {
    processDetailData: {},
    recentFailedTransactionsData: [],
    eventHistoryData: [],
    backupFileFinderData: [],
    recentSystemErrorsData: [],
    recentTransData: [],
    logList: [],
  },
  mutations: {
    'SET_PROCESS_DETAIL_DATA'(state, processDetailData) {
      state.processDetailData = processDetailData;
    },
    'SET_RECENT_FAILED_TRANSACTIONS_DATA'(state, recentFailedTransactionsData) {
      state.recentFailedTransactionsData = recentFailedTransactionsData;
    },
    'SET_RECENT_TRANS_DATA'(state, recentTransData) {
      state.recentTransData = recentTransData;
    },
    'SET_EVENT_HISTORY_DATA'(state, eventHistoryData) {
      state.eventHistoryData = eventHistoryData;
    },
    'SET_BACKUP_FILE_FINDER_DATA'(state, backupFileFinderData) {
      state.backupFileFinderData = backupFileFinderData;
    },
    'SET_RECENT_SYSTEM_ERRORS_DATA'(state, recentSystemErrorsData) {
      state.recentSystemErrorsData = recentSystemErrorsData;
    },
    'SET_STORE_LOG_LIST' (state, logList) {
      logList === '' ? state.logList = [] : state.logList = logList;
    },
  },
  actions: {
 
    getLogList: async ({commit}, params) => {
      var url = `${sysLogURI}/logs/custom-search`;
      const urlSearchParam = new URLSearchParams(params);
      if (Object.keys(params).length) {
        const query = urlSearchParam.toString();
        url += '?' + query;
      }
      try {
        const response = await axios.get(url);
        commit('SET_STORE_LOG_LIST', response.data);
      } catch (err) {
        throw err;
      }
    },
    getProcessDetailList: async ({ commit }, params) => {
      // https://albdev.smartlink-platform.com:3300/admin-helper/processes/1640328896721990926
      try {
        // const response = await axios.get(`${tempURI}/admin-helper/processes/${params.searchProcessId}`);
        let procDataList = [];
        let stateViewInfo = {};

        // https://albdev.smartlink-platform.com:3200/monitoring/users/cyberlogitec.com?filter=processId=1640773140063000230

        let url = `${monitoringURI}/monitoring/users/${params.ownerId}?filter=&orderBy=dateTime desc&page=1&perPage=1&processId=${params.searchProcessId}`;
        // let url = `https://alb.smartlink-platform.com:3200/monitoring/users/cyberlogitec.com?filter=&orderBy=dateTime desc&page=1&perPage=1&processId=1640841182373063760`;
        await axios.get(url).then(async (response) => {
          const response_proc = await axios.post(`${setupURI}/process/list/fortransaction`, params);
          const response_prnr = await axios.post(`${prnrURI}/partner/list`, params);

          const trsData = response.data.data;
          const procData = response_proc.data;
          const prnrData = response_prnr.data;

          for (let i = 0; trsData.length > i; i += 1) {
            for (let j = 0; procData.length > j; j += 1) {
              // 2021.9.17 203728 processSetupId-version
              if (trsData[i].processSetupId.includes(procData[j].processSetupId)) {

                trsData[i].processSetupName = procData[j].processSetupName;
                trsData[i].partnerId = procData[j].partnerId;
                trsData[i].direction = procData[j].direction;

                if (trsData[i].partnerId !== '') {
                  for (let k = 0; prnrData.length > k; k += 1) {
                    if (trsData[i].partnerId === prnrData[k].prnrId) {
                      trsData[i].partnerName = prnrData[k].prnrNm
                    }
                  }
                }
                break;
              }
            }
          }

          stateViewInfo = {
            groupId: trsData[0].groupId,
            userId: trsData[0].userId,
            processSetupId: trsData[0].processSetupId,
            processId: trsData[0].processId,
            messageSequence: trsData[0].record.messageSequence,
            senderId: trsData[0].record.messageInfo.senderId,
            recipientId: trsData[0].record.messageInfo.recipientId,
            messageName: trsData[0].record.messageInfo.messageName,
            partnerName: trsData[0].partnerName,
            direction: trsData[0].direction,
            transactionCode: trsData[0].transactionCode
          }
        });

        // url = `${tempURI}/admin-helper/processes/${params.searchProcessId}`;
        url = `${monitoringURI}/monitoring/users/${stateViewInfo.groupId}/${stateViewInfo.userId}/status/${stateViewInfo.processId}/${stateViewInfo.messageSequence}`;
        await axios.get(url).then(async (response_state) => {
          let data = response_state.data.data;

          for (let k = 0; data.length > k; k += 1) {
            let stateData = data[k].state;
            let response_proc = await axios.post(`${setupURI}/process/list/forstateinfo`, { processSetupId: data[k].processSetupId });
            let procData = response_proc.data;

            if (procData.length === 0) continue;

            let procList = [];
            for (let j = stateData.length - 1; j >= 0; j -= 1) {
              let index = procData.findIndex(e => (stateData[j].resourceId.includes(e.procCommId) || e.procCommId === stateData[j].mappingId));
              if (index > -1) {
                let record = { ...procData[index] };
                let id = procList.findIndex(e => e.procCommId === record.procCommId);
                if (id < 0 || stateData[j].transactionCode === 'SEND_O_DONE') {
                  record.transactionCode = stateData[j].transactionCode;
                  record.timestamp = stateData[j].timestamp;
                  record.errorMessage = stateData[j].errorMessage;
                  record.fileLink = stateData[j].fileLink;
                  record.userData = stateData[j].userData;
                  record.reProcess = '';
                  record.recordId = stateData[j].recordId;
                  record.processSetupId = data[k].processSetupId;
                  record.groupIndex = data.length - k;
                  record.processSetupName = `${data.length - k}. Workflow Name : ${record.procName} [${data[k].processSetupId}]`;
                  procList.push(record);
                }
              } else if (index === -1 && stateData[j].resourceId.includes('_mq_')) {
                if (stateData[j].transactionCode !== 'TRANS_I_DONE') {
                  procList.push({
                    procCommId: stateData[j].resourceId,
                    mqName: 'Internal Channel - mq - ' + stateData[j].resourceId.split('_')[2],
                    procType: 'MQ',
                    transactionCode: stateData[j].transactionCode,
                    timestamp: stateData[j].timestamp,
                    errorMessage: stateData[j].errorMessage,
                    fileLink: stateData[j].backupId,
                    userData: stateData[j].userData,
                    reProcess: '',
                    recordId: stateData[j].recordId,
                    processSetupId: data[k].processSetupId,
                    groupIndex: data.length - k,
                    procName: procData[0].procName,
                    processSetupName: `${data.length - k}. Workflow Name : ${procData[0].procName} [${data[k].processSetupId}]`
                  })
                }
              }
            }

            // 203728 sort desc
            procList.sort(function (a, b) {
              if (a.timestamp === b.timestamp) {
                // recordId is only important when timestamp are the same
                return b.recordId - a.recordId;
              }
              return b.timestamp > a.timestamp ? 1 : -1;
            })
            procDataList = procDataList.concat(procList);
          }
        });

        let len = procDataList.length;
        for (let i = 0; i < len; i += 1) {
          procDataList[i].INDEX = len - i;
        }
        commit('SET_PROCESS_DETAIL_DATA', { stateViewInfo: stateViewInfo, procDataList: procDataList });
      } catch (err) {
        throw err;
      }
    },
    getRecentFailedTransactionsList: async ({ commit }, params) => {
      // https://albdev.smartlink-platform.com:3300/admin-helper/transactions/fail?filter=group_id eq {ownr_id of login user}
      try {
        const response = await axios.get(`${tempURI}/admin-helper/transactions/fail?filter=group_id eq '${params.ownrId}'`);
        commit('SET_RECENT_FAILED_TRANSACTIONS_DATA', response.data);
      } catch (err) {
        throw err;
      }
    },
    getRecentTransactionList: async ({ commit }, params) => {
      // https://albdev.smartlink-platform.com:3300/admin-helper/transactions?filter=group_id eq {ownr_id of login user}
      try {
        const response = await axios.get(`${tempURI}/admin-helper/transactions?filter=group_id eq '${params.ownrId}'`);
        commit('SET_RECENT_TRANS_DATA', response.data);
      } catch (err) {
        throw err;
      }
    },
    getEventHistoryList: async ({ commit }, params) => {
      // https://albdev.smartlink-platform.com:3300/admin-helper/setups/1640220173905
      try {
        const response = await axios.get(`${tempURI}/admin-helper/setups/${params.searchProcessId}`);
        commit('SET_EVENT_HISTORY_DATA', response.data);
      } catch (err) {
        throw err;
      }
    },
    getBackupFileFinderList: async ({ commit }, params) => {
      // https://alb.smartlink-platform.com:3240/backups?filter=group_id={ownr_id of login user} and file_content like '%25a%25' AND request_timestamp BETWEEN '2023-06-28 03:00:00' AND '2023-06-28 03:05:00'
      let url = `${baseURI}/backups?filter=group_id eq '${params.ownrId}' AND `;
      if (params.fileName != '') {
        url += `file_name like '%25${params.fileName}%25' AND `;
      }
      if (params.fileContent != '') {
        url += `file_content like '%25${params.fileContent}%25' AND `;
      }
      url += `request_timestamp BETWEEN '${params.fromDateData}' AND '${params.toDateData}'`
      try {
        console.log(url)
        const response = await axios.get(url, {
          withCredentials: true,
        });
        commit('SET_BACKUP_FILE_FINDER_DATA', response.data);
      } catch (err) {
        throw err;
      }
    },
    getRecentSystemErrorsData: async ({ commit }, params) => {
      // https://albdev.smartlink-platform.com:3300/admin-helper/errors?filter=group_id eq {ownr_id of login user}
      try {
        const response = await axios.get(`${tempURI}/admin-helper/errors?filter=group_id eq '${params.ownrId}'`);
        commit('SET_RECENT_SYSTEM_ERRORS_DATA', response.data);
      } catch (err) {
        throw err;
      }
    },
    checkProcessSetupEvent: async ({ commit }, params) => {
      return await axios.post(`${setupURI}/processhistory/check-admin-helper`, params).then((response) => {
        return response.data;
      }).catch((ex) => {
        throw ex;
      });
    },
  },
  getters: {
    processDetailData: state => state.processDetailData,
    recentFailedTransactionsData: state => state.recentFailedTransactionsData,
    eventHistoryData: state => state.eventHistoryData,
    backupFileFinderData: state => state.backupFileFinderData,
    recentSystemErrorsData: state => state.recentSystemErrorsData,
    recentTransData: state => state.recentTransData,
    logList: state => state.logList,
  },
};

export default adminStoreModule;
